export enum Languages {
    EN = 'en',
    DE = 'de'
}
